import type { Theme } from '@mui/material/styles';
import { MtComStyleObj } from './MtComStyleObj';

export const materialDownloadBtnDisabled = (theme: Theme) => ({
    minWidth: { xs: '100%', sm: 180 },
    width: { xs: '100%', sm: 'auto' },
    height: 40,
    borderRadius: '8px',
    fontWeight: 700,
    fontSize: { xs: 13, sm: 14 },
    ...MtComStyleObj(theme).disabledGreenBtnStyle,
});

export const EventsReportStyleObj = {
    pageContainer: { px: { xs: 1.5, sm: 2, md: 3 }, pt: { xs: 1.5, sm: 2 }, pb: 0 },
    backRow: { display: 'flex', alignItems: 'center', gap: 1, mb: 1, cursor: 'pointer' },
    backIcon: { fontSize: { xs: 18, sm: 20 }, color: '#000000' },
    backLabel: { fontSize: { xs: 16, sm: 18, md: 20 } },
    titleRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: { xs: 2, sm: 3 } },
    title: { color: '#1E1E1E', fontSize: { xs: 22, sm: 28, md: 32, lg: 36 }, lineHeight: 1.2 },
    card: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: { xs: 1.5, sm: 2 },
        backgroundColor: '#FFFFFF',
        border: '1px solid #E5E7EB',
        borderRadius: { xs: '12px', sm: '16px' },
        boxShadow: '0px 2px 6px rgba(16, 24, 40, 0.08)',
        p: { xs: 1.5, sm: 2, md: 3 },
        boxSizing: 'border-box',
    },
    sectionHeaderRow: {
        pb: { xs: 1.5, sm: 1 },
        borderBottom: '1px solid #E5E7EB',
    },
    sectionTextWrap: { minWidth: 0 },
    sectionTitle: { color: '#1E1E1E', fontSize: { xs: 16, sm: 18, md: 20 } },
    sectionSubtitle: { color: '#4B5563', fontSize: { xs: 12, sm: 13, md: 14 } },
    materialDownloadBtn: {
        minWidth: { xs: '100%', sm: 180 },
        width: { xs: '100%', sm: 'auto' },
        height: 40,
        borderRadius: '8px',
        fontWeight: 700,
        fontSize: { xs: 13, sm: 14 },
    },
    eventRow: {
        flexDirection: { xs: 'column', md: 'row' },
        gap: 2,
        alignItems: { xs: 'stretch', md: 'flex-end' },
    },
    eventFormStack: { flex: 1, minWidth: 0, width: '100%' },
    customDateLabel: { ml: 0.5, fontSize: { xs: 13, sm: 14 } },
    dateRangeToggle: { ml: 0, mr: 0, alignSelf: 'flex-start' },
    checkbox: { padding: '6px', '& .MuiSvgIcon-root': { fontSize: 20 } },
    checkboxIcon: { width: 20, height: 20, display: 'block' },
    rangeFieldContainer: { width: { xs: '100%', sm: 360, md: 400 }, maxWidth: '100%' },
    fieldLabel: { mb: 1, fontSize: { xs: 13, sm: 14 } },
    fullWidth: { width: '100%' },
    dateAdornmentIconBtn: {
        '&:focus': { outline: 'none' },
        '&.Mui-focusVisible, &:focus-visible': { outline: 'none', boxShadow: 'none' },
    },
    dateAdornmentImage: { width: 16, height: 16 },
    eventsDownloadBtn: {
        minWidth: { xs: '100%', md: 170 },
        width: { xs: '100%', md: 'auto' },
        height: 44,
        borderRadius: '8px',
        fontWeight: 700,
        fontSize: { xs: 14, sm: 15, md: 16 },
        flexShrink: 0,
        alignSelf: { xs: 'stretch', md: 'flex-end' },
    },
    selectField: (theme: Theme) => ({
        ...MtComStyleObj(theme).textFocusHoverStyle,
        ...MtComStyleObj(theme).textBoxValueStyle,
        height: 40,
    }),
    dateRangeField: (theme: Theme) => ({
        width: '100%',
        ...MtComStyleObj(theme).textFocusHoverStyle,
        ...MtComStyleObj(theme).textBoxValueStyle,
        ...MtComStyleObj(theme).placeHolderStyle,
    }),
    eventsDownloadBtnDisabled: (theme: Theme) => ({
        ...EventsReportStyleObj.eventsDownloadBtn,
        ...MtComStyleObj(theme).disabledGreenBtnStyle,
    }),
};
